import React, { useContext, useState } from "react";
import ListadoSupport from "./ListadoSupport";
import { AuthContext } from "../../context/AuthContext";

const SupportAdmin = () => {
  const { token } = useContext(AuthContext);

  const [tab] = useState("listado");
  const [debeRecargar, setDebeRecargar] = useState(false);

  const renderTab = () => {
    if (tab === "listado") {
      return <ListadoSupport token={token} debeRecargar={debeRecargar}
        onRecargaCompleta={() => setDebeRecargar(false)} />;
    }
    return null;
  };

  return (
    <div className="productos-admin-content">
      <div className="productos-admin-header">
        <div className="productos-admin-header-row">
          <div>
            <div className="productos-admin-title">Cola de Soporte</div>
            <div className="productos-admin-subtitle">
              Gestión de solicitudes
            </div>
          </div>
        </div>
        
      </div>
      <div className="productos-admin-tab-content">{renderTab()}</div>
    </div>
  );
};

export default SupportAdmin;
